import React, { useMemo, useState } from "react";
import { AppContext } from "./context/AppContext";

import Controller from "./components/Controller";
import Map from "./components/Map";
import filterLocations from "./utils/filterLocations";
import findMiddleGround, { haversineDistance } from "./utils/findMiddleGround";
import ResultsList from "./components/ResultsList";

const KM_TO_MILES = 0.621371;

// Straight-line miles from an address to a venue
const milesFrom = (address, location) => {
  const [lon, lat] = location.geometry.coordinates;
  return (
    haversineDistance(address.center[1], address.center[0], lat, lon) *
    KM_TO_MILES
  );
};

function App() {
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [searched, setSearched] = useState(false);
  const [filters, setFilters] = useState([]);
  const [locations, setLocations] = useState([]);
  const [resultNum, setResultNum] = useState(5);
  const [selectedId, setSelectedId] = useState(null);

  // Recomputed whenever the addresses, filters or result count change, so the
  // map never has to recalculate results itself
  const middleGround = useMemo(() => {
    if (!searched || !address1 || !address2) return [];
    const locs =
      filters.length > 0 ? filterLocations(locations, filters) : locations;
    return findMiddleGround(address1, address2, locs, resultNum).map(
      (location, i) => ({
        ...location,
        properties: {
          ...location.properties,
          rank: i + 1,
          milesFromA: milesFrom(address1, location),
          milesFromB: milesFrom(address2, location),
        },
      })
    );
  }, [searched, address1, address2, locations, filters, resultNum]);

  return (
    <div className="App">
      <AppContext.Provider
        value={{
          address1,
          setAddress1,
          address2,
          setAddress2,
          middleGround,
          searched,
          setSearched,
          locations,
          setLocations,
          filters,
          setFilters,
          resultNum,
          setResultNum,
          selectedId,
          setSelectedId,
        }}
      >

        <aside className="panel">
          <Controller />
          <ResultsList />
        </aside>

        <div className="map-area">
          <Map />
        </div>
      </AppContext.Provider>
    </div>
  );
}

export default App;
